import handleDSOperation from '../../functions/handleDSOperation'

const onRowDelete = async (row) => {
  await handleDSOperation(null, 'delete', row.id)
}

export default onRowDelete
